/**
 * Service: paymentSettings
 */
angular.module('acme.common.service.paymentSettings', [
  'acme.common.service.themesHelper'
])
.service('PaymentSettingsService', ['ThemesHelperService', function(ThemesHelperService) {

    return {

      displayFields: {
        address: [],
        zipcode: [],
        none: []
      },

      validationFields: {
        address: [],
        zipcode: [],
        none: []
      },

      settings: ThemesHelperService.getCCValidationSettings(),

      init: function() {
        return true;
      },

      checkFieldProperties: function(property, field) {

        var r = false;


        if (property === 'address') {

          switch (field) {
            case 'address-create-country-select':
            /* falls through */
            case 'address-create-country-input':
            /* falls through */
            case 'address-create-state-select':
            /* falls through */
            case 'address-create-state-input':
            /* falls through */
            case 'country':
            /* falls through */
            case 'otherCountry':
            /* falls through */
            case 'streetAddress1':
            /* falls through */
            case 'streetAddress2':
            /* falls through */
            case 'address1':
            /* falls through */
            case 'address2':
            /* falls through */
            case 'city':
            /* falls through */
            case 'state':
            /* falls through */
            case 'otherState':
            /* falls through */
            case 'zip':
            /* falls through */
            case 'zipCode':
              r = true;
          }

        } else if (property === 'zipcode') {
          switch (field) {
            case 'zip':
            /* falls through */
            case 'zipCode':
              r = true;
              break;
          }
        } else if (property === 'none') {
          if (field === 'none') {
            r = true;
          }
        }


        return r;

      },

      checkFieldValidation: function(name) {

        var validation = 'none';

        if (this.settings.hasOwnProperty('b2bValidation')) {
          validation = this.settings.b2bValidation.toLowerCase();
        }

        console.log('AddressCreate::checkFieldDisplay', validation, name);

        return this.checkFieldProperties(validation, name);

      },

      checkFieldDisplay: function(name) {

        var display = 'address';

        if (this.settings.hasOwnProperty('b2bDisplay')) {
          display = this.settings.b2bDisplay.toLowerCase();
        }

        console.log('AddressCreate::checkFieldDisplay', display, name);

        return this.checkFieldProperties(display, name);

      }

    };

}]);